import { ComponentType, FC } from 'react';
import useLinhaTempoStore from '../store';
import Header from './header';
import { LinhaTempoViewMode } from '../types';
import CurrentWeekTable from '../view-modes/current-week';

const VIEW_MODES_COMPONENTS: Record<LinhaTempoViewMode, ComponentType> = {
  currentWeek: CurrentWeekTable,
};

const BottomSheet: FC = () => {
  const viewMode = useLinhaTempoStore((store) => store.filtros.viewMode);

  const ViewModeComponent = VIEW_MODES_COMPONENTS[viewMode];

  return (
    <div className="bottom-sheet">
      <Header />
      <ViewModeComponent />
    </div>
  );
};

export default BottomSheet;
